import React, { Component } from "react";
import HomeChart from "../../../../../../helper/homechart.helper";

class AreaChartHolder extends Component {
  componentDidMount() {
    this.renderAssetStylePieChart(this.props.res);
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.res) !== JSON.stringify(nextProps.res)) {
      this.renderAssetStylePieChart(nextProps.res);
    }
  }

  renderAssetStylePieChart(data) {
    HomeChart.renderAssetStyleStockChart(
      "#asset_class_stock_place",
      "",
      "",
      "",
      data
    );
  }

  render() {
    return (
      <div
        id="asset_class_stock_place"
        style={{ width: "100%", height: "600px" }}
      />
    );
  }
}

export default AreaChartHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/section1/areaChartHolder.jsx